/* eslint-disable */
import toyotaPhoto from '../imgs/toyota.png';
import lexusPhoto from '../imgs/lexus.png';
import afcat from '../imgs/antifreeze.cat.png';
import acat from '../imgs/aroma-cat.png';
import bcat from '../imgs/brushes-cat.png';
import fcat from '../imgs/finish-cat.png';
import wcat from '../imgs/wheels-cat.png';
import {getUserId} from '../logic/authHelpers';
import {getPartnerId} from '../logic/api.js';
import config from 'src/config';

export default {
  searchState: {
    searchResult: [],
    partnerLocations: [],
    foundDetail: {},
    foundDetailOffers: [],
    inStock: false,
    priceMinValue: 0,
    priceMaxValue: 0,
    isAskSupplier: true,
    bestOfferValue: '',
    supplierFilterValues: []
  },
  categoriesState: {
     brandList: []
  },
  catalogState: {
    brand: {},
    model:{},
    modification:{},
    modelList: [],
    modificationList: [],
    maintenanceDetailList: []
  },
  registrationPopupState: {
    isOpen: false,
    phoneNumber: '',
    password: '',
    isLoading: false,
    currentStep: 1,
    regInputCurStep: 1,
    sentNumberErr: '',
    sentPasswordErr: '',
    vkErr: '',
    fbErr: ''
  },
  toCartPopupState: {
    isOpen: false,
    name: '',
    description: '',
    toCartQuantity: 1,
    chosenPartner: getPartnerId(),
    price: '',
    toCartPopupComment: ''
  },
  signInPopupState: {
    isOpen: false,
    isLoading: false,
    isResettingPassword: false,
    loginErr: '',
    resetPasswordErr: '',
    fbErr: '',
    vkErr: ''
  },
  cartState: {
    balance: 0,
    selfPickupLatLng: {...config.defaultMapCenter},
    selectedShippingMethod: config.defaultShippingMethod,
    // latLng: {...config.defaultMapCenter},
    latLng: {},
    isShippingAvailable: true, //todo set it to true
    shippingAddress: {},
    address: 'г. Москва ул. Генерала Белова, д.16',
    isShowingMapBalloon: true, //todo set it to false and
    // switch to true after receiving all the stuff
    cartItems: []
  },
  appState: {
    userId: getUserId(),
    isAuthenticated: false,
    seenItems: [
      {
        photo: lexusPhoto,
        name: 'Lexus IS 250-220D седан II (E20)',
        description: '2005 — наст. время, 220 D'
      },
      {
        photo: toyotaPhoto,
        name: 'Toyota Camry седан VII (V50)',
        description: '2011 — наст. время, 2.5'
      }
    ],
    mainPageCategories: [
      {
        name: 'Моторные масла',
        withSelects: true,
        params: [
          {
             name: 'Производитель'
          },
          {
             name: 'Вязкость'
          },
          {
             name: 'Объем упаковки'
          },
          {
             name: 'Тип двигателя'
          }
        ]
      },
      {
        name: 'Ароматизаторы',
        photo: acat,
        links: [
          'Autoprofi',
          'Eikosha',
          'Hi-gear',
          'Liqui Moly',
          'Sapfire',
          'TopCar',
          'Zeus'
        ]
      },
      {
        name: 'Антифризы',
        photo: afcat,
        links: [
          'Зеленый',
          'Красный',
          'Синий',
          'Жёлтый'
        ]
      },
      {
        name: 'Щетки стеклоочистителя',
        photo: bcat,
        links: [
          'Каркасные',
          'Бескаркасные',
          'Гибридные'
        ]
      },
      {
        name: 'Внешний декор',
        photo: fcat,
        links: [
          'Брызговики',
          'Водухозаборники',
          'Глушители',
          'Подлокотники',
          'Расширители колесных арок',
          'Решетка радиатора',
          'Спойлер'
        ]
      },
      {
        name: 'Аккумуляторы',
        withSelects: true,
        params: [
          {
             name: 'Производитель'
          },
          {
             name: 'Вязкость'
          },
          {
             name: 'Пусковой ток'
          },
          {
             name: 'Полярность'
          }
        ]
      },
      {
        name: 'Шины',
        withSelects: true,
        params: [
          {
             name: 'Производитель'
          },
          {
             name: 'Сезонность'
          },
          {
             name: 'Диаметр'
          },
          {
             name: 'Ширина'
          },
          {
             name: 'Высота'
          }
        ]
      },
      {
        name: 'Колеса',
        photo: wcat,
        links: [
          'Bridgestone',
          'Borbet',
          'BBS',
          'Toyo',
          'Yokohama',
          'Work'
        ]
      },
      {
        name: 'Диски',
        withSelects: true,
        params: [
          {
             name: 'Производитель'
          },
          {
             name: 'Диаметр'
          },
          {
             name: 'Кол-во и диаметр расположения отверстий'
          }
        ]
      }
    ]
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/initialState.js
 **/